// extracted by mini-css-extract-plugin
export default {"documentList":"approvedModal_documentList__ywPUb","documentRow":"approvedModal_documentRow__v0iZ7","subtitle":"approvedModal_subtitle__U-8bZ"};